import React from 'react';
import {withRouter} from "react-router";
import PropTypes from 'prop-types';
import playerParams from "./playerParams";
import InteractivePlayerContainer from "./InteractivePlayerContainer";
import {PLAYER_WAS_STARTED} from "./withPlayerManager";
import {PLAYBACK_READY, VIDEO_FINISHED} from "./PlayerEventNames";
import withErrorBoundary from "../../Errors/components/withErrorBoundry";

export const LOAD_POP_OUT_PLAYER_EVENT = 'SPL_PLAYER_LOAD_IN_POP_OUT';
export const POP_OUT_PLAYER_PLACEHOLDER_ID = 'static-route-independent-player';

export class PopOutPlayer extends React.Component {
  state = {
    articleUrl: undefined
  }

  handleLoadPopOutPlayer = (event) => {
    if (!event || !event.detail) {
      return;
    }

    const articlePlayer = event.detail.player;
    const articleUrl = event.detail.articleUrl;

    if (!articlePlayer || !articlePlayer.getEmbedCode || !articlePlayer.getPlayheadTime) {
      return;
    }

    this.setState({articleUrl}, () => {
      this.showPlayer(articlePlayer.getEmbedCode(), articlePlayer.getPlayheadTime())
    });
  }

  showPlayer = (contentId, playheadTime) => {
    if (!window.OO) {
      return;
    }

    window.OO.ready(() => {
      if (this.state.popOutPlayer) {
        this.state.popOutPlayer.destroy(() => {
          this.createPlayer(contentId, playheadTime);
        })
      } else {
        this.createPlayer(contentId, playheadTime);
      }
    });
  }

  onPlaybackReady = () => {
    this.interactivePlayer.onPlayerReady && this.interactivePlayer.onPlayerReady();
    this.interactivePlayer.setPopOutState(true);
    const containerElement = document.getElementById(POP_OUT_PLAYER_PLACEHOLDER_ID);
    const videoElements = containerElement && containerElement.getElementsByTagName('video');
    if (videoElements && videoElements.length === 1) {
      const videoElement = videoElements[0];
      videoElement && videoElement.setAttribute("webkit-playsinline", true)
      videoElement && videoElement.setAttribute("playsinline", true)
    }

    if (!this.state.popOutPlayer.isPlaying()) {
      this.state.popOutPlayer.play();
    }
  };

  createPlayer = (contentId, playheadTime) => {
    this.setState({popOutPlayer: window.OO.Player.create(POP_OUT_PLAYER_PLACEHOLDER_ID, contentId, {
      ...playerParams,
      initialTime: playheadTime,
      autoplay: true
    })}, () => {
      this.state.popOutPlayer.mb.subscribe(VIDEO_FINISHED , '', this.dismissPlayer);
      this.state.popOutPlayer.mb.subscribe(PLAYBACK_READY, '', this.onPlaybackReady)
    });
  }

  dismissPlayer = () => {
    if (!this.state.popOutPlayer || !this.interactivePlayer) {
      return;
    }

    this.interactivePlayer.setPopOutState(false).then(() => {
      this.state.popOutPlayer.destroy();
      this.setState({popOutPlayer: undefined})
    });
    this.state.popOutPlayer.pause();
  }

  setInteractivePlayer = ref => { this.interactivePlayer = ref }

  returnToArticle = () => {
    if (!this.state.articleUrl) {
      return;
    }

    this.onReturnToArticle = this.dismissPlayer;
    this.props.router.push(this.state.articleUrl);
  }

  onRouteChange = (event) => {
    if (event.pathname === this.state.articleUrl) {
      this.onReturnToArticle && this.onReturnToArticle();
    }
  };

  componentDidMount() {
    this.props.router.listen(this.onRouteChange);
    window.addEventListener(PLAYER_WAS_STARTED, this.dismissPlayer);
    window.addEventListener(LOAD_POP_OUT_PLAYER_EVENT, this.handleLoadPopOutPlayer);
  }

  componentWillUnmount() {
    window.removeEventListener(LOAD_POP_OUT_PLAYER_EVENT, this.handleLoadPopOutPlayer);
    window.removeEventListener(PLAYER_WAS_STARTED, this.dismissPlayer);
  }

  render() {
    return (
      <InteractivePlayerContainer
        ref={this.setInteractivePlayer}
        dismissPlayer={this.dismissPlayer}
        player={this.state.popOutPlayer}
        articleUrl={this.state.articleUrl}
        onMobilePopOutPress={this.returnToArticle}
      >
        <div id={POP_OUT_PLAYER_PLACEHOLDER_ID} />
      </InteractivePlayerContainer>
    )
  }
}

PopOutPlayer.propTypes = {
  router: PropTypes.shape({
    listen: PropTypes.func,
    push: PropTypes.func
  })
}

export const loadToGlobalPlayer = (player, articleUrl) => {
  const event = new CustomEvent(LOAD_POP_OUT_PLAYER_EVENT, {
    detail: {player, articleUrl}
  });

  window.dispatchEvent(event)
}

export default withErrorBoundary(withRouter(PopOutPlayer));



// WEBPACK FOOTER //
// ./modules/Ooyala/component/PopOutPlayer.js